export interface AppwriteConfig {
  endpoint: string;
  projectId: string;
  projectName: string;
  managementFunctionId: string;
  /** Acciones que un usuario hace sobre su propia cuenta o contenido. */
  accountFunctionId: string;
  /** Catálogo y entrega de recursos de audio. */
  mediaFunctionId: string;
  /** El chat vive en su propia Function para poder crecer aparte. */
  chatFunctionId: string;
  /** Acciones de juego genéricas (hoy: dados). */
  gamesFunctionId: string;
  /** Estado y gestión del motor Rungo para el panel de Sistema. */
  rungoFunctionId: string;
}

function value(name: string, configured: string | undefined, fallback: string): string {
  const result = configured?.trim() || fallback;
  if (!result) throw new Error(`Falta configurar ${name}.`);
  return result;
}

export const appwriteConfig: AppwriteConfig = {
  endpoint: value(
    'VITE_APPWRITE_ENDPOINT',
    import.meta.env.VITE_APPWRITE_ENDPOINT,
    'https://api.rolsensorial.com/v1',
  ),
  projectId: value(
    'VITE_APPWRITE_PROJECT_ID',
    import.meta.env.VITE_APPWRITE_PROJECT_ID,
    '6a8d9306003401764927',
  ),
  projectName: value(
    'VITE_APPWRITE_PROJECT_NAME',
    import.meta.env.VITE_APPWRITE_PROJECT_NAME,
    'RolSensorial',
  ),
  managementFunctionId: value(
    'VITE_MANAGEMENT_FUNCTION_ID',
    import.meta.env.VITE_MANAGEMENT_FUNCTION_ID,
    'management-command',
  ),
  accountFunctionId: value(
    'VITE_ACCOUNT_FUNCTION_ID',
    import.meta.env.VITE_ACCOUNT_FUNCTION_ID,
    'account',
  ),
  mediaFunctionId: value(
    'VITE_MEDIA_FUNCTION_ID',
    import.meta.env.VITE_MEDIA_FUNCTION_ID,
    'media',
  ),
  chatFunctionId: value(
    'VITE_CHAT_FUNCTION_ID',
    import.meta.env.VITE_CHAT_FUNCTION_ID,
    'chat',
  ),
  gamesFunctionId: value(
    'VITE_GAMES_FUNCTION_ID',
    import.meta.env.VITE_GAMES_FUNCTION_ID,
    'games',
  ),
  rungoFunctionId: value(
    'VITE_RUNGO_FUNCTION_ID',
    import.meta.env.VITE_RUNGO_FUNCTION_ID,
    'rungo',
  ),
};
